// Campus photo for /colleges/university-of-california-merced: CC BY-SA 3.0, by Qymekkam, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AKolligan_library.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-merced/; credited under the photo.
const photo = {
    "slug": "university-of-california-merced",
    "alt": "The Kolligian Library at UC Merced in Merced, California",
    "src": "/colleges/university-of-california-merced/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-merced/campus-800.webp",
    "srcMid": "/colleges/university-of-california-merced/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-merced/og.jpg",
    "title": "Kolligan library",
    "author": "Qymekkam",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AKolligan_library.jpg",
    "read": "2026-09-30"
};

export default photo;
